import React from 'react';
import { useAuth } from '../contexts/AuthContext';

interface PermissionGuardProps {
  children: React.ReactNode;
  resource: string;
  action: string;
  fallback?: React.ReactNode;
  requireAll?: boolean;
  permissions?: Array<{ resource: string; action: string }>;
}

const PermissionGuard: React.FC<PermissionGuardProps> = ({
  children,
  resource,
  action,
  fallback = null,
  requireAll = false,
  permissions,
}) => {
  const { hasPermission, loading } = useAuth();

  if (loading) {
    return null; // Don't render anything while loading
  }

  // If permissions array is provided, check multiple permissions
  if (permissions) {
    const hasAllPermissions = permissions.every(p => hasPermission(p.resource, p.action));
    const hasAnyPermission = permissions.some(p => hasPermission(p.resource, p.action));
    
    if (requireAll && !hasAllPermissions) {
      return <>{fallback}</>;
    }
    
    if (!requireAll && !hasAnyPermission) {
      return <>{fallback}</>;
    }
    
    return <>{children}</>;
  }

  // Single permission check
  if (!hasPermission(resource, action)) {
    return <>{fallback}</>;
  }

  return <>{children}</>;
};

export default PermissionGuard;
